__turbopack_context__.v({
  "container": "LanguageOptionLabel-module-scss-module__DFC7Va__container",
  "flag": "LanguageOptionLabel-module-scss-module__DFC7Va__flag",
});
